import script from "./OSelecionarProjetosGrupo.vue?vue&type=script&lang=ts&setup=true"
export * from "./OSelecionarProjetosGrupo.vue?vue&type=script&lang=ts&setup=true"

import "./OSelecionarProjetosGrupo.vue?vue&type=style&index=0&id=1c68a1a4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c68a1a4"]])

export default __exports__